export enum MessageType {
  EVENT = 'EVENT',
  CALL = 'CALL',
}
